import styled, { css } from 'styled-components';
import { colors } from 'constants/colors';
import { addStyleIfPropTruly } from '../../utils/styledComponents';
import { getMultipliedIndentFromProp } from '../../theme/selectors';
import { EnumSize } from 'constants/enums';
import { mediaSmDown } from 'theme/helpers/css';

interface IRatingButton {
  image: string;
  onClick?: () => void;
  active?: boolean;
  size: EnumSize;
  disabled?: boolean;
}

const SIZE_RATING_BUTTON = {
  [EnumSize.lg]: css`
    width: 80px;
    height: 80px;
    background-size: 46px;
    margin-right: ${getMultipliedIndentFromProp(6)};

    ${mediaSmDown`
      width: 44px;
      height: 44px;
      background-size: 26px;
      margin-right: ${getMultipliedIndentFromProp(4)}
    `}
  `,
  [EnumSize.md]: css`
    width: 50px;
    height: 50px;
    background-size: 28px;
    & + & {
      margin-left: ${getMultipliedIndentFromProp(4)};
    }
  `,
  [EnumSize.sm]: css`
    width: 40px;
    height: 40px;
    background-size: 23px;
    margin-right: ${getMultipliedIndentFromProp(2)};
  `,
  [EnumSize.xs]: css`
    width: 40px;
    height: 40px;
    background-size: 23px;
    margin-right: ${getMultipliedIndentFromProp(2)};
  `,
};

const SIZE_RATING_BUTTON_MOBILE = {
  [EnumSize.lg]: css`
    width: 80px;
    height: 80px;
    background-size: 46px;
    margin-right: ${getMultipliedIndentFromProp(6)};
  `,
  [EnumSize.md]: css`
    width: 44px;
    height: 44px;
    background-size: 28px;
    & + & {
      margin-left: ${getMultipliedIndentFromProp(2)};
    }
  `,
  [EnumSize.sm]: css`
    width: 44px;
    height: 44px;
    background-size: 23px;
    & + & {
      margin-left: ${getMultipliedIndentFromProp(2)};
    }
  `,
  [EnumSize.xs]: css`
    width: 40px;
    height: 40px;
    background-size: 23px;
    margin-right: ${getMultipliedIndentFromProp(2)};
  `,
};

const RatingButton = styled.div<IRatingButton>`
  border-radius: 50%;
  box-shadow: 0 2px 6px 0 ${colors.blackTwo5}, 0 0 4px 0 ${colors.blackTwo5};
  background: ${colors.white} no-repeat center;
  will-change: transform;
  transform: scale(1);
  transition-property: transform;
  transition-delay: 16ms;
  transition-duration: 48ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
  cursor: pointer;
  flex-shrink: 0;

  ${({ size }) => SIZE_RATING_BUTTON[size]};
  ${({ image }) => image && `background-image: url(${image});`};

  ${mediaSmDown`
    ${({ size }: IRatingButton) => SIZE_RATING_BUTTON_MOBILE[size]};
  `}

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    background-color: ${colors.silver};
    box-shadow: none;
  }

  ${addStyleIfPropTruly(
    'active',
    `
      transform: scale(1.14);
      background-color: ${colors.silver};
      box-shadow: none;
    `
  )};

  ${addStyleIfPropTruly('disabled', 'opacity: 0.6')}
`;

export const SendedRatingContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: ${colors.silver};
  height: 50px;
  border-radius: 25px;
  padding: 6px 16px;
`;

export const SendedRatingImage = styled.img`
  width: 28px;
  display: block;
  margin-right: 12px;
`;

export default RatingButton;
